import { Injectable, Inject } from '@angular/core';
import { SESSION_STORAGE, LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Subject } from 'rxjs';

const STORAGE_KEY = 'acu-storage'

@Injectable({
  providedIn: 'root'
})
export class AcuStorageService {

  accessibilitySubject = new Subject<boolean>();

  constructor(
    @Inject(SESSION_STORAGE) private sessionStorage: StorageService,
    @Inject(LOCAL_STORAGE) private localStorage: StorageService
  ) { }

  public getObjectInStorage<T>(key: string): T{
    return this.localStorage.get(STORAGE_KEY.concat(key));
  }

  public setObjectInStorage<T>(key: string, value: T){
    this.localStorage.set(STORAGE_KEY.concat(key), value);
  }

  public removeObjectFromStorage(key: string){
    this.localStorage.remove(STORAGE_KEY.concat(key));
  }

  public hasObjectInStorage(key: string): boolean{
    return this.localStorage.has(STORAGE_KEY.concat(key));
  }

  public setJwtToken<T>(value: string){
    this.localStorage.set(`${STORAGE_KEY}-jwt`, value);
  }

  public getJwtToken(): string{
    return this.localStorage.get(`${STORAGE_KEY}-jwt`) || '';
  }

  public setStoredUser<T>(user: T) {
    this.sessionStorage.set(`${STORAGE_KEY}-logged-user`, user);
    this.localStorage.set(`${STORAGE_KEY}-logged-user`, user);
    if (user) {
      this.localStorage.set(`${STORAGE_KEY}-last-known-user`, user);
    }
  }

  public getStoredUser<T>(): T | null {
    const sessionUser = this.sessionStorage.get(`${STORAGE_KEY}-logged-user`);
    if (sessionUser) return sessionUser;
    return this.localStorage.get(`${STORAGE_KEY}-logged-user`) || null;
  }

  public getLastKnownUser<T>(): T | null {
    return this.localStorage.get(`${STORAGE_KEY}-last-known-user`) || null;
  }

  public removeStoredUser() {
    this.sessionStorage.remove(`${STORAGE_KEY}-logged-user`);
    this.localStorage.remove(`${STORAGE_KEY}-logged-user`);
  }

  public setRedirectUrl(url: string) {
    this.sessionStorage.set(`${STORAGE_KEY}-redirect-url`, url);
  }

  public getAndClearRedirectUrl(): string | null {
    const url = this.sessionStorage.get(`${STORAGE_KEY}-redirect-url`);
    if (url) {
      this.sessionStorage.remove(`${STORAGE_KEY}-redirect-url`);
    }
    return url || null;
  }

  public clearDataCache() {
    const keysToClear = [
      'listaSediUffici',
      'allPrenotazioni',
      'consuntivo_allData',
      'consuntivo_lastUpdate'
    ];
    keysToClear.forEach(key => this.removeObjectFromStorage(key));
  }

}
